import { Panel, Box, Flex } from '@sequencehq/core-components'
import { dashboard20240730Client } from '@sequencehq/api/dashboard/v20240730'
import { QuoteSummary, ReactQuoteRenderer } from '@sequencehq/quote-content'
import { QuoteEditorPreviewProps } from 'modules/Cube/view/layouts/quote/QuoteEditorPreview/QuoteEditorPreview.types'
import { useQuoteEditorPreviewRoot } from 'modules/Cube/view/layouts/quote/QuoteEditorPreview/useQuoteEditorPreviewRoot'
import { Header } from 'modules/Cube/view/layouts/quote/QuoteEditorPreview/widgets/Header'

export const QuoteEditorPreviewRoot = (props: QuoteEditorPreviewProps) => {
  const rootHook = useQuoteEditorPreviewRoot(props)

  return (
    <Panel
      position="absolute"
      top="0"
      left="0"
      width="100%"
      height="100%"
      zIndex="110"
      display="flex"
      flexDirection="column"
      data-testid="quote.preview-content"
    >
      <Header hook={rootHook} />
      <Flex overflowY="scroll" flex="1">
        <Flex width="100%" height="fit-content">
          <ReactQuoteRenderer
            data-testid="quote.preview-content.renderer"
            forceLatestPresentationStyling={true}
            data={rootHook.reactRendererData}
            assetLoader={async ({ assetId }) => {
              const res = await dashboard20240730Client.getAsset({
                id: assetId
              })

              if (!res.data || res.error) {
                return undefined
              }

              return { urlSigned: res.data.url }
            }}
            trailingSideContent={
              <Box position="sticky" top="48px">
                <QuoteSummary
                  currentUserEmail={undefined}
                  footer={undefined}
                  data-testid="quote.preview-content.summary"
                />
              </Box>
            }
            trailingContentMinWidth={1468}
          />
        </Flex>
      </Flex>
    </Panel>
  )
}
